<template>
    <div :class="{ 'c-dark-theme': false }" class="c-app">
        <the-sidebar />
        <div class="wrapper d-flex flex-column min-vh-100">
            <the-header />
            <sticky-banner />
            <div class="c-body">
                <main class="c-main">
                    <container class="mb-3" fluid>
                        <slot />
                    </container>
                </main>
            </div>
            <div v-if="isImpersonating" class="fixed right-0 bottom-0 left-0 z-[9999] flex justify-between gap-4 bg-warning px-5 py-3">
                <markdown
                    :wrap-paragraphs="false"
                    class="truncate"
                    :content="
                        trans('general.user.impersonation.description', {
                            user: username,
                        })
                    "
                />
                <a href="#" @click.stop="leaveImpersonation()">{{ trans('general.user.impersonation.action.leave') }}</a>
            </div>
            <the-footer />
        </div>
    </div>
</template>

<script setup>
import { router } from '@inertiajs/vue3';
import TheSidebar from '@/Containers/TheSidebar.vue';
import TheHeader from '@/Containers/TheHeader.vue';
import TheFooter from '@/Containers/TheFooter.vue';
import Container from '@/Components/Container.vue';
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import Markdown from '@/Jetstream/Markdown.vue';
import StickyBanner from '@/Components/StickyBanner.vue';

const page = usePage();
const username = computed(() => page.props.auth.user?.name ?? '');
const isImpersonating = computed(() => page.props.auth.isImpersonating);

function leaveImpersonation() {
    router.get(route('users.leave-impersonate'));
}
</script>
